module.exports = __webpack_public_path__ + "img/icon_connetUs.8644795a.png";